var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.881 28.5H12.7857C5.4542 28.5 1.78846 28.5 0.437576 26.1154C-0.913307 23.7308 0.96166 20.5697 4.7116 14.2476L7.75924 9.10943C11.3614 3.03648 13.1624 0 15.8333 0C18.5042 0 20.3053 3.03647 23.9074 9.10942L26.9551 14.2476C30.705 20.5697 32.58 23.7308 31.2291 26.1154C29.8782 28.5 26.2125 28.5 18.881 28.5Z",
    fill: "#C62828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 9.5V16.625",
    stroke: "#FEE1E1",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 22.1543V22.1708",
    stroke: "#FEE1E1",
    strokeWidth: 2.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert3);
export default __webpack_public_path__ + "static/media/alert-3.c88ffd4038d40cf50f82d42ab1188389.svg";
export { ForwardRef as ReactComponent };